import React from 'react'
import './style.css'
import Button from '../../CtaButton'
import AuraBannerVideo from '../AuraBannerVideo/AuraBannerVideo'
import AuraButtonGreen from '../AuraButton/AuraButtonGreen'

const AuraBanner = () => {
    return (
        <>
            {/* <div class="gradient-wave"></div> */}
            <section className="position-relative aura-banner-page overflow-hidden">
                <div className="container text-center">
                    <h1 className="aura-banner-main-heading">
                        Empowering Clinics With Smarter, Faster Patient Care
                        {/* <span className="text-aura-accent">MBS Reporting</span> */}
                    </h1>

                    <p className="description-text description-text-box">
                        Aura Clinic streamlines patient journeys with digital onboarding, real time check-ins, efficient scheduling, and MBS-ready workflows, ensuring smooth clinic operations and enhanced care.
                    </p>

                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3">
                        <AuraButtonGreen text="Book Demo" link="#" />

                        {/* <AuraButtonGreen text="Learn More" appearance="outline" link="/solutions/auraclinic/flow" /> */}
                    </div>

                    <AuraBannerVideo />

                    {/* Dashboard preview */}
                    {/* <div className="aura-dashboard mx-auto">
                        <div className="card border-0 shadow">
                            <div className="card-header d-flex align-items-center bg-aura-primary text-white py-2 px-3 rounded-0">
                                <div className="d-flex gap-2">
                                    <span className="aura-dot bg-danger" />
                                    <span className="aura-dot bg-warning" />
                                    <span className="aura-dot bg-success" />
                                </div>
                                <span className="ms-3 small text-white-50">
                                    Aura Clinic Dashboard
                                </span>
                            </div>
                            <div className="card-body rounded-0 p-4">
                                <div className="row g-3 mb-3">
                                    {[
                                        {
                                            label: "Patients Today",
                                            value: "42",
                                            change: "+8 from yesterday",
                                        },
                                        {
                                            label: "MBS Claims",
                                            value: "$12,450",
                                            change: "98% approved",
                                        },
                                        {
                                            label: "Appointments",
                                            value: "28",
                                            change: "4 healthcare",
                                        },
                                        {
                                            label: "Compliance Score",
                                            value: "99%",
                                            change: "All compliant",
                                        },
                                    ].map((stat, idx) => (
                                        <div className="col-6 col-md-3" key={idx}>
                                            <div className="card border-0 h-100 aura-stat-card">
                                                <div className="card-body p-3">
                                                    <p className="small text-muted mb-1">{stat.label}</p>
                                                    <p className="h4 fw-bold text-aura-primary mb-1">
                                                        {stat.value}
                                                    </p>
                                                    <p className="small text-aura-accent mb-0">
                                                        {stat.change}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="card border-0 h-100">
                                            <div className="card-body p-3 text-left">
                                                <p className="small fw-semibold text-muted mb-2">
                                                    Recent Activity
                                                </p>
                                                <ul className="list-unstyled mb-0 small text-muted">
                                                    <li className="mb-1">
                                                        ● New patient onboarded - Sarah M.
                                                    </li>
                                                    <li className="mb-1">
                                                        ● MBS claim approved - $285
                                                    </li>
                                                    <li>● Appointment confirmed - 2:30 PM</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="card border-0 h-100">
                                            <div className="card-body p-3">
                                                <p className="small fw-semibold text-muted mb-2">
                                                    Today&apos;s Schedule
                                                </p>
                                                <div className="small">
                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="text-muted">9:00 AM - Dr. Smith</span>
                                                        <span className="text-aura-accent">Healthcare</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="text-muted">
                                                            10:30 AM - Dr. Johnson
                                                        </span>
                                                        <span className="text-aura-primary">In-Person</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="text-muted">
                                                            2:00 PM - Dr. Williams
                                                        </span>
                                                        <span className="text-aura-accent">Healthcare</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>
        </>
    )
}

export default AuraBanner